<template>
  <v-row>
    <div v-if="getTabs().length">
      <v-sheet :width="fixedRowWidth" class="pl-5">
        <swiper
          class="swiper"
          ref="swipes"
          :options="swiperOptions"
          style="margin-bottom: -15px"
          v-if="show"
        >
          <swiper-slide v-for="(value, index) in getTabs()" :key="index">
            <div
              v-ripple="{ center: true }"
              class="rewards-offers"
              :class="[
                value == activeReward &&
                  !$vuetify.breakpoint.xsOnly &&
                  'rewards-offers-active',
                type === 'points' ? 'justify-space-between' : 'justify-center',
              ]"
              style="height: 190px"
              @click.stop="toggleRewards(value)"
            >
              <PointsTab v-if="type === 'points'" :offer="value.xtra" />
              <ClubTab v-if="type === 'clubs'" :club="value" />
            </div>
          </swiper-slide>
          <div
            v-if="$vuetify.breakpoint.smAndUp"
            class="swiper-button-next"
            slot="button-next"
          ></div>
          <div
            v-if="$vuetify.breakpoint.smAndUp"
            class="swiper-button-prev"
            slot="button-prev"
          ></div>
        </swiper>
      </v-sheet>
      <div
        :style="{ width: fixedRowWidth }"
        style="overflow-x: clip"
        class="mb-10"
      >
        <RewardProducts
          v-if="activeReward && !$vuetify.breakpoint.xsOnly"
          :products="getProducts()"
          :title="getTitle()"
        />
      </div>
    </div>
  </v-row>
</template>

<script>
import PointsTab from "./PointsTab.vue";
import ClubTab from "./ClubTab.vue";
import RewardProducts from "./RewardProducts.vue";

export default {
  name: "RewardsTabs",
  components: {
    PointsTab,
    ClubTab,
    RewardProducts,
  },
  computed: {
    fixedRowWidth() {
      return this.$vuetify.breakpoint.xsOnly
        ? `100vw`
        : `${this.innerWidth - 298}px`;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: this.getTabCount(),
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      show: true,
      activeReward: null,
      innerWidth: window.innerWidth,
    };
  },
  methods: {
    getProducts() {
      let products;
      if (this.type === "points") {
        products = this.activeReward.xtra.products;
      } else {
        products = this.activeReward.products;
      }
      return products.map((p) => {
        return {
          ...p,
          redeemable: this.redeemable,
          loyalty: true,
        };
      });
    },
    getTabCount() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 2.5;
        case "sm":
          return 3.5;
        case "md":
          return 6;
        case "lg":
          return 10;
        case "xl":
          return 11;
      }
    },
    getTabs() {
      if (this.type === "clubs") {
        return this.clubs;
      } else {
        return this.points;
      }
    },
    getTitle() {
      if (this.type === "points") {
        return `${this.activeReward.xtra.name} (${this.activeReward.xtra.points} points)`;
      } else {
        let availableRewards = this.activeReward.free_products_qty
          ? `(${this.activeReward.free_products_qty} reward${
              this.activeReward.free_products_qty > 1 ? "s" : ""
            } available) `
          : "";
        return `${this.activeReward.name} ${availableRewards}`;
      }
    },
    routeToPayWithPoints() {
      this.$store.dispatch("product/setCurrentProductDetails", {
        name: this.activeReward.xtra.name,
        paywithpoints: true,
        redemption_points_offer: this.activeReward.points,
        redemption_points_offer_id: this.activeReward.offering_id,
      });

      this.$router.push({
        name: "rewardProduct",
        query: {
          points_offer: this.activeReward.offering_id,
          view: "details",
        },
      });
    },
    routeToRewardsProducts() {
      this.$router.push({
        name: "rewardsProducts",
        query: {
          ...(this.type === "points" && {
            points_offer: this.activeReward.offering_id,
          }),
          ...(this.type !== "points" && {
            club_offer: this.activeReward.club_id,
          }),
        },
      });
    },
    toggleRewards(value) {
      this.activeReward = this.activeReward == value ? null : value;
      this.$root.$emit("tabClick", this.activeReward);
      if (this.$vuetify.breakpoint.xsOnly) {
        if (this.type === "points" && this.activeReward.xtra.paywithpoints) {
          this.routeToPayWithPoints();
        } else {
          this.routeToRewardsProducts();
        }
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
    this.$root.$on("tabClick", (data) => {
      if (data != this.activeReward) {
        this.activeReward = null;
      }
    });
  },
  props: {
    clubs: Array,
    type: String,
    points: Array,
    redeemable: Boolean,
  },
  watch: {
    breakpoint() {
      this.swiperOptions.slidesPerView = this.getTabCount();
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style scoped>
.rewards-offers {
  flex-grow: 0;
  margin: 0 16px 0 0;
  padding: 9px 0 16px;
  mix-blend-mode: darken;
  border-radius: 2px;
  background-color: #f5f5f5;
  border-bottom: 22px solid white;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: IDTSans;
  font-size: 14px;
}
.rewards-offers-active {
  background-color: var(--v-background-base);
  border-bottom: 10px solid var(--v-background-base);
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  pointer-events: auto;
  display: none;
}

.swiper-button-next {
  color: var(--color-indigo);
  /*pointer-events: none;*/
  right: 0;
  z-index: 0;
}
.swiper-button-next:after {
  font-size: 20px;
}

.swiper-button-prev {
  color: var(--color-indigo);
  left: 0;
  z-index: 0;
}
.swiper-button-prev:after {
  font-size: 20px;
}
</style>
